import {Box, Checkbox, FormControlLabel, InputAdornment, TextField} from '@mui/material';
import {formatEmailList} from '../../../utils/email';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import PropTypes from 'prop-types';
import {TooltipWrapperIssue} from '../../TooltipWrapperIssue.jsx';

/**
 * Display a form element with a Checkbox, Label and Textfield, that can display a list of emails
 * @param {Object} props
 * @return {JSX.Element}
 * @constructor
 */
export function CheckableSupplierEmails(props) {
    const disableCheckbox = props.disableIfEmpty !== undefined ? props.emails.length === 0 : false;

    const textField = () => {
        return (
            <TextField
                variant='standard' fullWidth
                disabled={props?.disableCheckbox || props.disableText !== undefined ? props.disableText : disableCheckbox }
                inputRef={(input) => {
                    // update the value of the textfield, when it is updated asynchronously after first render
                    if (input !== null) {
                        input.value = formatEmailList(props.emails);
                    }
                }}
                onChange={(event) => {
                    if (event.nativeEvent.data === ' ') {
                        props.onTextChange(event.target.value + ';');
                    }
                }}
                onBlur={(event) => props.onTextChange(event.target.value)}
                InputProps={{
                    startAdornment: ( props.loading &&
                        <InputAdornment position="start">
                            <CircularProgress size={20} />
                        </InputAdornment>
                    ),
                }}
            />
        );
    };

    return <Box sx={{display: 'flex', alignItems: 'center'}} gap={1}>
        <FormControlLabel
            style={{width: props.controlLabelWidth ? props.controlLabelWidth : '350px'}}
            control={
                <Checkbox
                    checked={props.checked}
                    onChange={(event) => props.onChecked(event.target.checked)}
                />
            }
            label={props.label}
            disabled={props?.disableCheckbox || disableCheckbox}
        />
        {!props.disableTooltip ? <TooltipWrapperIssue
            open={props.tooltipOpen}
            onClose={props.tooltipOnClose}
            error={props.tooltipError}
        >
            {textField()}
        </TooltipWrapperIssue> :
            textField()
        }
    </Box>;
}

CheckableSupplierEmails.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    emails: PropTypes.array,
    loading: PropTypes.bool,
    onChecked: PropTypes.func,
    onTextChange: PropTypes.func,
    disableIfEmpty: PropTypes.bool,
    disableText: PropTypes.bool,
    controlLabelWidth: PropTypes.string,
    disableCheckbox: PropTypes.bool,
    tooltipOpen: PropTypes.bool,
    tooltipOnClose: PropTypes.func,
    tooltipError: PropTypes.object,
    disableTooltip: PropTypes.bool,
};
